/* Native Wishlist parity. The current app screen owns tab and empty-state
   behaviour only. Future live rows remain behind the authenticated test gate. */

(function () {
  var copy = {
    priceDrops: 'Save pieces you love and we’ll watch for price drops.',
    restocks: 'Save sold-out sizes here and we’ll let you know when they’re back.',
    saved: 'Move pieces from your bag here when you want to think it over.'
  };

  function view() {
    return document.querySelector('[data-gettmi-wishlist]');
  }

  function settings() {
    return document.querySelector('[data-gettmi-settings]');
  }

  function selectTab(key) {
    var box = view();
    if (!box || !copy[key]) return;

    box.querySelectorAll('[data-gettmi-wishlist-tab]').forEach(function (tab) {
      var selected = tab.dataset.gettmiWishlistTab === key;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    var label = box.querySelector('[data-gettmi-wishlist-copy]');
    if (label) label.textContent = copy[key];
  }

  function openWishlist() {
    var box = view();
    if (!box) return;
    var profile = settings();
    if (profile) profile.hidden = true;
    box.hidden = false;
    document.documentElement.classList.add('gettmi-overlay-open');
    selectTab('restocks');
    var back = box.querySelector('[data-gettmi-wishlist-close]');
    if (back) back.focus();
  }

  function closeWishlist() {
    var box = view();
    if (box) box.hidden = true;
    var profile = settings();
    if (profile) {
      profile.hidden = false;
      document.documentElement.classList.add('gettmi-overlay-open');
      var opener = profile.querySelector('[data-gettmi-open-wishlist]');
      if (opener) opener.focus();
      return;
    }
    document.documentElement.classList.remove('gettmi-overlay-open');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-gettmi-open-wishlist]')) {
      openWishlist();
      return;
    }

    if (event.target.closest('[data-gettmi-wishlist-close]')) {
      closeWishlist();
      return;
    }

    var tab = event.target.closest('[data-gettmi-wishlist-tab]');
    if (tab) selectTab(tab.dataset.gettmiWishlistTab);
  }, true);

  document.addEventListener('keydown', function (event) {
    var box = view();
    if (event.key === 'Escape' && box && !box.hidden) closeWishlist();
  });
})();
